/**
 * JS : Date Of Birth
 *
 * Product by Ocumetra
 *
 */
import { removeError } from "./error_validation_system";
import { FormValidator } from "./form_validator/form_validator.js";
import { ExtraError } from "./form_validator/extensions/constants.js";

/**
 * Shows the age when the age/date are validated, otherwise displays an error
 */
export function showAge() {
    const dobDate = document.getElementById("dob-date");
    const dateIsValid = dobDate.value !== "";
    const errorInputDOB = document.getElementById("dob-entry-error");
    const errorRangeDOB = document.getElementById("error-range-dob");
    const containerDOB = document.getElementById("container-dob");
    const currentAge = document.getElementById("current-age");
    const currentAgeMonths = document.getElementById("current-age-months");
    const hasContainerDOBclass =
        containerDOB.classList.contains("container-dob");
    const shouldValidate = !errorRangeDOB.classList.contains("no-validate");
    const form = FormValidator.getInstance("submit-guide-form");

    errorInputDOB.style.visibility = "visible";

    function failDate(message) {
        currentAge.style.display = "none";
        containerDOB.setAttribute("required", "required");
        errorRangeDOB.style.display = "inline-block";
        errorRangeDOB.innerText = message;
        errorInputDOB.style.visibility = "hidden";
        form?.addExtraError(ExtraError.AGE_RANGE);
    }

    function calculateAge(dobValue, visitValue) {
        const dob = new Date(dobValue);
        const visit = visitValue ? new Date(visitValue) : new Date();
        let years = visit.getFullYear() - dob.getFullYear();
        let months = visit.getMonth() - dob.getMonth();
        if (months < 0) {
            months += 12;
            years -= 1;
        }
        return { years, months };
    }

    function showValidAgeUI(years, months) {
        document.getElementById("age-years").innerText = years;
        currentAge.style.display = "inline-block";
        window.dispatchEvent(
            new CustomEvent("valid-dob", { detail: { age: years } })
        );

        if (months !== 0) {
            document.getElementById("age-months").innerText = months;
            currentAgeMonths.style.display = "inline-block";
        } else {
            currentAgeMonths.style.display = "none";
        }

        errorRangeDOB.style.display = "none";
        containerDOB.removeAttribute("required");
        removeError($("#container-dob"));
        disableSubmitButton(false);
        form?.removeExtraError(ExtraError.AGE_RANGE);
    }

    function showInvalidAgeUI(message) {
        disableSubmitButton();
        failDate(message);
    }

    if (!dateIsValid && shouldValidate) {
        failDate(errorRangeDOB.dataset.invalidDateMessage);
        return;
    }

    errorInputDOB.style.visibility = "visible";

    if (!shouldValidate && hasContainerDOBclass) {
        containerDOB.style.visibility = dateIsValid ? "visible" : "hidden";
    }

    if (!dateIsValid) return;

    const visitDateInput = document.querySelector("input[name=visit_date]");
    const { years, months } = calculateAge(
        dobDate.value,
        visitDateInput?.value
    );

    if (years >= 6 && years < 19) {
        showValidAgeUI(years, months);
    } else if (years < 6 || years >= 19) {
        const dobYear = new Date(dobDate.value).getFullYear();
        if (dobYear > 1000) {
            showInvalidAgeUI(errorRangeDOB.dataset.invalidAgeRangeMessage);
        }
    }
}

export function disableSubmitButton(disable = true) {
    const scoreSubmitButton = document.getElementById(
        "submit-new-score-form-submitter"
    );
    const guideSubmitButton = document.getElementById(
        "submit-guide-form-submitter"
    );

    if (scoreSubmitButton) {
        scoreSubmitButton.disabled = disable;
    }

    if (guideSubmitButton) {
        guideSubmitButton.disabled = disable;
    }
}

/**
 * Get the date (today) according to the format/dateFormat
 * @param {*} format
 * @returns the current date
 */
export function getDate(date = "") {
    date = date ? date : Date.now();
    return new Intl.DateTimeFormat(["default", "en-GB"], {
        year: "numeric",
        month: "short",
        day: "2-digit",
    }).format(date);
}

/**
 * Check if the DOB is valid or not.
 * @param {string} value
 * @returns {boolean} true/false
 */
export function validDate(value) {
    return !isNaN(Date.parse(new Date(value)));
}

/**
 * Check if the date instance is valid or not.
 * @param {Date} date
 * @returns {boolean} true/false
 */
export function validDateInstance(date) {
    return !isNaN(Date.parse(date));
}

/**
 * Recalculate age everytime visit date changes.
 */
function handleDateInputs() {
    const visitDateInput = document.querySelector("input[name=visit_date]");
    const dobInput = document.querySelector("input[name=dob_date]");
    if (visitDateInput) {
        visitDateInput.addEventListener("input", () => {
            showAge();
        });
    }
    if (dobInput) {
        dobInput.addEventListener("input", () => {
            showAge();
        });
    }
}

// Launch the library to the load.
window.addEventListener("load", () => {
    handleDateInputs();
});
